const FilesCell = ({ files }) => {
    return (
        <p className="mb-0 fw-semibold">
            {files.length} File{files.length > 1 && 's'}
        </p>
    )
}

export default FilesCell